import { render, staticRenderFns } from "./FloatButton1.vue?vue&type=template&id=f1139066&scoped=true&"
import script from "./FloatButton1.vue?vue&type=script&lang=js&"
export * from "./FloatButton1.vue?vue&type=script&lang=js&"
import style0 from "./FloatButton1.vue?vue&type=style&index=0&id=f1139066&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1139066",
  null
  
)

export default component.exports